import type EnType from '../en-US/environment';

export default {
  'environment.manageModal.title': 'Variables Personales',
  'environmentDetail.label.server': 'URL Base',
  'environmentDetail.label.variables': 'Variables',
  'environmentDetail.label.variables.tips':
    'Inserta {{var_name}} en los valores de los parámetros para reutilizar valores en diferentes endpoints y parámetros.',
  'environment.title.variableName': 'Nombre',
  'environment.title.variableName.placeholder': 'Agregar una nueva variable',
  'environment.title.addVariableValue': 'Agregar Variable',
  'environment.title.value': 'Valor',
  variableNameEmptyError: 'El nombre es requerido',
  preFixUrl: 'URL Prefijo',
  'editor.tip': 'El formato de datos sigue',
  filedBulkEdit: 'Edición Masiva',
  'environment.title.serviceName': 'Nombre del Servicio',
  'environment.manageModal.tip':
    'Estos valores se almacenan localmente en tu navegador y no se sincronizarán a la nube.',
  'environment.manageModal.tip.clickToSetVariable':
    'Haz clic para establecer la variable: {variableName} (Valor actual: {variableValue})',
  'baseURL.colon': 'URL Base: ',
  'environment.variable.notSet': 'No establecido',
  byComma: 'Por coma',
  byColon: 'Por dos puntos',
} satisfies typeof EnType;
